import { RouteObject } from "../../helpers/tixxt-router";
import { lazy, Suspense } from "react";
import Loading from "../shared/Loading";

const ProfileOnboardingPage = lazy(() => import("./ProfileOnboardingPage"));

const onboardingRoutes: RouteObject[] = [
  {
    path: "/onboarding/profile",
    element: (
      <Suspense fallback={<Loading />}>
        <ProfileOnboardingPage />
      </Suspense>
    ),
    forceTurbo: true,
  },
];

export default onboardingRoutes;
